<script>
export default {
  data() {
    return {
      showModal: false
    }
  },

  props: ['modal', 'leilao', 'dados'],

  watch: {
    leilao: {
      handler(newLeilao) {
        this.showModal = !!(newLeilao && newLeilao.id && this.dados.leilao_id);
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    fecharPopup() {
      this.showModal = false;
      this.$emit('fecharModalPopup', false)
    }
  }
}
</script>

<template>
  <span v-if="leilao.length === 0"/>
  <div v-else class="modal_TRT" @click="fecharPopup" v-show="modal && leilao.id == dados.leilao_id">
    <span class="corpo_TRT">
      <a :href="dados.nm_link" target="_blank">
        <img class="popup"
             :src="dados.img_path"
             :alt="dados.nm_descricao">
      </a>
      <button @click="fecharPopup" class="btn-fechapopup" v-html="'FECHAR'"/>
    </span>
  </div>
</template>

<style scoped>
.corpo_TRT:hover {
  opacity: 1;
  transition: 0.5s ease-in-out;
  bottom: 0;
}

.modal_TRT {
  width: 100% !important;
  height: 100% !important;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(11, 11, 11, 0.12);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.modal_TRT img {
  max-width: 980px;
  border-radius: 10px;
}

.corpo_TRT {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

@media (max-width: 991px) {
  .corpo_TRT {
    margin: 0 20px;
  }
}

@media (max-width: 1440px) {
  .popup {
    width: 100%;
  }
}

@media (max-width: 1024px) {
  .v--modal-overlay .v--modal-box {
    left: 7em !important;
    width: 850px !important;
    height: auto !important;
    top: 4em !important;
  }

  .popup {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .v--modal-overlay .v--modal-box {
    left: 5em !important;
    width: 635px !important;
    top: 7em !important;
  }
}

@media (max-width: 425px) {
  .v--modal-overlay .v--modal-box {
    left: 5px !important;
    width: 415px !important;
    top: 15em !important;
  }
}

.btn-fechapopup {
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  border-radius: 8px;
  background: red;
  padding: 15px;
  color: #fff;
  font-size: 18px !important;
  font-weight: bold;
  margin: auto !important;
  margin-top: 10px !important;
  width: 60%;
}

.btn-fechapopup:hover {
  background: darkred;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/modalPoupSalaDeDisputa.vue